import React, { Component } from 'react';
import axios from 'axios';
import lodash from 'lodash';
import '../../../assets/css/giftmanager.css';
import $ from 'jquery';
import { Link } from "react-router-dom";
import ModalUpdateAvatarFrame from './ModalUpdateAvatarFrame';
import ModalShowSVGA from '../components/ModalShowSVGA';
import ModalShowGiftAnimation from '../components/ModalShowGiftAnimation';
import ModalDeleteShopItem from '../components/ModalDeleteShopItem';
import ShopItemRow from '../components/ShopItemRow';
import ShopToolbar from '../components/ShopToolbar';
import LoaiHeaderFilter from '../components/LoaiHeaderFilter';
import { toast } from 'react-toastify';

/** Số dòng hiển thị lần đầu khi mở trang */
const MOUNT_STEP = 20;
/** Cuộn tới cuối bảng -> hiện thêm từng này */
const SCROLL_STEP = 20;

export default class AvatarFrame extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gifts: [],
            gift: null,
            status: "",
            show: "",
            type: "",
            tag: "",
            tableLoading: false,
            // Số dòng đang render (mount dần khi cuộn -> mở trang nhanh)
            mountedCount: MOUNT_STEP,
            // Lọc theo loại: 'ALL' | 'SYSTEM' | 'NORMAL'
            sourceTypeFilter: 'ALL',
            // Từ khoá tìm theo ID hoặc tên
            keyword: '',
            // cursor: null,
            // statusButtonLoadPage: false,
        }

        this.getGifts = this.getGifts.bind(this);
        this.loadMoreGifts = this.loadMoreGifts.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleTransfer = this.handleTransfer.bind(this);
        this.handleLoaiFilter = this.handleLoaiFilter.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handleSentinelRef = this.handleSentinelRef.bind(this);
        this.mountMore = this.mountMore.bind(this);
    }

    componentDidMount() {
        // Load dữ liệu (thay cho componentWillMount đã deprecated)
        this.getGifts();

        $("#modalUpdateGift").on("hidden.bs.modal", function () {
            this.setState({
                gift: null
            });
        }.bind(this));

        console.log("Did mount")
        $("#modalShowGift").on("hidden.bs.modal", function () {
            this.setState({
                giftShow: null
            });
        }.bind(this));

        $("#modalShowGiftAnimation").on("hidden.bs.modal", function () {
            this.setState({
                giftShow: null
            });
        }.bind(this));

        // Cuộn tới cuối bảng -> mount thêm dòng (tự động, không cần nút bấm)
        this.setupSentinelObserver();
    }

    componentWillUnmount() {
        if (this.sentinelObserver) {
            this.sentinelObserver.disconnect();
            this.sentinelObserver = null;
        }
    }

    getGifts(reset) {
        this.setState({ tableLoading: true });

        let obj = {
            // cursor: this.state.cursor,
            typeString: "AvatarFrame"
        }
        // if (reset == true) {
        //     obj.cursor = null
        // }

        axios.post(global.config.apiDomain + '/rest/shop-items/getItemWithPage', obj)
            .then(res => {
                this.setState({
                    gifts: res.data.listItem || [],
                    tableLoading: false
                });
            })
            .catch(() => {
                // Không để màn hình treo "Đang tải..." mãi
                this.setState({ tableLoading: false });
            });
    }

    transferMedalData(itemShop){
        let url = global.config.apiDomain + "/rest/shop-items/transferDataItemShop"
        this.setState({
            loading : true
        })

        axios.post(url,itemShop)
        .then(res =>{
            if(res.data.status == "OK"){
                toast.success(res.data.message)
            }else{
                toast.warning("Error: " + res.data.message)
            }
        })
    }

    loadMoreGifts() {
        // const { loading } = this.state;
        // if (!loading) {
        //     this.setState({
        //         loading: true
        //     });
        //     this.getGifts();
        // }
    }

    /** Bỏ dấu + chuyển thường để tìm kiếm dễ (gõ "dong mv" ra "động mv"). */
    normalizeText(value) {
        if (value == null) return '';
        return String(value)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd');
    }

    /**
     * Lấy danh sách item sau khi áp filter "Loại" + ô tìm kiếm (ID hoặc tên).
     * Chạy trên TOÀN BỘ danh sách đã tải nên tìm được cả item chưa cuộn tới.
     */
    getFilteredGifts() {
        const { gifts, sourceTypeFilter, keyword } = this.state;
        let list = gifts || [];

        if (sourceTypeFilter && sourceTypeFilter !== 'ALL') {
            list = list.filter((g) => g && g.sourceType === sourceTypeFilter);
        }

        const kw = this.normalizeText(keyword).trim();
        if (kw) {
            list = list.filter((g) => g && (
                this.normalizeText(g.name).indexOf(kw) !== -1 ||
                this.normalizeText(g._id).indexOf(kw) !== -1
            ));
        }

        return list;
    }

    /** Bấm Sửa / Xóa trên 1 dòng -> mở modal tương ứng với item đó. */
    handleEdit(gift) {
        this.setState({ gift: gift });
    }

    handleDelete(gift) {
        this.setState({ gift: gift });
    }

    handleTransfer(gift) {
        if (window.confirm("Bạn có chắc là muốn chuyển dữ liệu: " + gift.name + " ?")) {
            this.transferMedalData(gift);
        }
    }

    /** Đổi filter "Loại" -> hiển thị lại từ 20 dòng đầu. */
    handleLoaiFilter(value) {
        this.setState({ sourceTypeFilter: value, mountedCount: MOUNT_STEP });
    }

    /** Gõ ô tìm kiếm -> lọc lại và hiển thị từ 20 dòng đầu. */
    handleKeywordChange(value) {
        this.setState({ keyword: value, mountedCount: MOUNT_STEP });
    }

    /** Cuộn tới cuối bảng -> mount thêm dòng (KHÔNG gọi API, dữ liệu đã có sẵn). */
    mountMore() {
        const total = this.getFilteredGifts().length;
        this.setState((s) => ({
            mountedCount: Math.min(s.mountedCount + SCROLL_STEP, total)
        }));
    }

    /** <tr> "sentinel" ở cuối bảng: khi nó vào viewport thì mount thêm dòng. */
    handleSentinelRef(el) {
        this.sentinelEl = el;
        if (!this.sentinelObserver) return;
        this.sentinelObserver.disconnect();
        if (el) this.sentinelObserver.observe(el);
    }

    setupSentinelObserver() {
        if (typeof window.IntersectionObserver === 'undefined') return;
        this.sentinelObserver = new window.IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) this.mountMore();
            });
        }, { rootMargin: '150px' });
    }

    render() {
        const filtered = this.getFilteredGifts();
        const rows = filtered.slice(0, this.state.mountedCount);
        const hasMore = rows.length < filtered.length;

        return (
            <>
                <ModalUpdateAvatarFrame resetList={this.getGifts} gift={this.state.gift}></ModalUpdateAvatarFrame>
                <ModalShowGiftAnimation gift={this.state.giftShow}></ModalShowGiftAnimation>
                <ModalShowSVGA gift={this.state.giftShow}></ModalShowSVGA>
                <ModalDeleteShopItem resetList={this.getGifts} gift={this.state.gift}></ModalDeleteShopItem>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí Shop khung avatar</h1>
                        <div>
                            <button
                                className="btn btn-red"
                                data-toggle="modal"
                                data-target="#modalUpdateAvatarFrame"
                                onClick={() => {
                                    this.setState({
                                        gift: {
                                            dateEnd: new Date(),
                                            dateStart: new Date()
                                        },
                                    })
                                }}
                            >Thêm mới Item</button>

                            <Link className="btn btn-red ml-2" to="/admin/rank-items">
                                Biểu đồ tiêu thụ Item
                            </Link>

                            <ShopToolbar
                                keyword={this.state.keyword}
                                onKeywordChange={this.handleKeywordChange}
                            />


                        </div>
                        <table className="table table-hover">
                            <thead>
                                <tr className="align-middle">
                                    <th className="align-middle" scope="col">Độ ưu tiên</th>
                                    <th className="align-middle" scope="col">ID</th>
                                    <th className="align-middle" scope="col">Tên</th>
                                    <th className="align-middle" scope="col">Thời gian sử dụng</th>
                                    <th className="align-middle" scope="col">Hình vật phẩm</th>
                                    <LoaiHeaderFilter value={this.state.sourceTypeFilter} onChange={this.handleLoaiFilter} />
                                    <th className="align-middle" scope="col">Giá bán</th>
                                    <th className="align-middle" scope="col">Ngày bắt đầu</th>
                                    <th className="align-middle" scope="col">Ngày kết thúc</th>
                                    <th className="align-middle" scope="col">Level thường</th>
                                    <th className="align-middle" scope="col">LevelVip</th>
                                    <th className="align-middle" scope="col">ID được mua</th>
                                    <th className="align-middle" scope="col">Hành động</th>
                                    <th className="align-middle" scope="col">Chuyển đổi dữ liệu</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tableLoading && (
                                    <tr>
                                        <td colSpan="14" className="text-center py-3">Đang tải…</td>
                                    </tr>
                                )}
                                {!this.state.tableLoading && filtered.length === 0 && (
                                    <tr>
                                        <td colSpan="14" className="text-center py-3">Không có dữ liệu</td>
                                    </tr>
                                )}
                                {rows.map((gift) => (
                                    <ShopItemRow
                                        key={gift._id}
                                        gift={gift}
                                        onEdit={this.handleEdit}
                                        onDelete={this.handleDelete}
                                        onTransfer={this.handleTransfer}
                                        editModalId="#modalUpdateAvatarFrame"
                                        deleteModalId="#modalDeleteShopItem"
                                    />
                                ))}
                                {hasMore && (
                                    <tr ref={this.handleSentinelRef}>
                                        <td colSpan="14" style={{ height: "1px", padding: 0 }}></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* {
                            statusButtonLoadPage ?
                                (<div onClick={this.loadMoreGifts} className="view_more w-100 text-center mb-lg-4">
                                    <a className="d-none d-md-block">
                                        <span>{loading ? "ĐANG TẢI ..." : "TẢI THÊM"}</span>
                                    </a>
                                    <a className="view_more_mobile d-md-none">
                                        <i className="fa fa-angle-down" aria-hidden="true" />
                                    </a>
                                </div>) :
                                ('')
                        } */}
                    </div>
                </div>
            </>
        );
    }
}
